// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 154 ? "cb6d98a4" : chunkId) + "." + {"34":"a3bea709fdf6b786","129":"e0ada5e94d2bdf99","154":"a788adff56c859bf"}[chunkId] + ".js";
};